import React, { useState, useRef, useEffect } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const OPTIONS = [
  { id: "light", label: "Light", icon: Sun },
  { id: "dark", label: "Dark", icon: Moon },
  { id: "system", label: "System", icon: Monitor },
];

export default function ThemeToggle({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const Current = OPTIONS.find(o => o.id === theme) || OPTIONS[0];
  const CurrentIcon = Current.icon;

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button data-testid="theme-toggle" onClick={()=>setOpen(!open)}
        aria-label="Theme"
        className="w-10 h-10 rounded-full border-2 border-slate-200 dark:border-slate-700 grid place-items-center text-slate-700 dark:text-slate-200 hover:border-slate-300 dark:hover:border-slate-500 bg-white dark:bg-slate-800">
        <CurrentIcon size={16}/>
      </button>
      {open && (
        <div data-testid="theme-menu" className="absolute right-0 mt-2 w-40 rounded-2xl border-2 border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg overflow-hidden z-50">
          {OPTIONS.map(o => {
            const Icon = o.icon;
            const active = theme === o.id;
            return (
              <button key={o.id} data-testid={`theme-${o.id}`}
                onClick={()=>{ setTheme(o.id); setOpen(false); }}
                className={`w-full text-left px-4 py-2.5 text-sm font-semibold flex items-center gap-2 ${active ? 'bg-indigo-600 text-white' : 'text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700'}`}>
                <Icon size={14}/> {o.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
